export default __webpack_public_path__ + "static/media/8-bit-pusab.f2ce33d4.ttf";